module.exports = __webpack_public_path__ + "static/media/Cats Eyes 09_FRANSKA-mixdown.d94797d8.mp3";